import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BackOfficeLayout from "../../../components/backoffice-layout";
import ButtonComponent from "../../../components/button";
import IconReport from "../../../assets/images/icon-report-2.svg"
import { useNavigate, useParams } from "react-router-dom";
import SuccessModal from "../../../components/modal/success";
import LoadingModal from "../../../components/loading-modal";
import DropdownComponent from "../../../components/evaluation-form-components/dropdown";
import InputComponent from "../../../components/evaluation-form-components/input";
import CoreAPI from "../../../services/core";
import IconPlace from "../../../assets/images/icon-location.svg";
import IconEvent from "../../../assets/images/icon-calendar-1.svg";
import IconService from "../../../assets/images/icon-report-1.svg";
import DatePickerComponent from "../../../components/evaluation-form-components/date_picker";
import TimePickerComponent from "../../../components/evaluation-form-components/time_picker";
import IconXLSX from "../../../assets/images/icon-xlsx.svg"
import IconClear from "../../../assets/images/icon-close-4.svg"
import { checkFormatEvaluationFormData, formatExceltoJSON, onGroupBy } from "../../../utils/default";
import EvaluationFormLayout from "../../../components/evaluation-form-layout";
import IconArrow from '../../../assets/images/icon-prev.svg'
import ConfirmModal from "../../../components/modal/confirm";
import QRCode from "react-qr-code";
import * as htmlToImage from "html-to-image";
import dayjs from "dayjs";
import IconPrinter from '../../../assets/images/icon-printer.svg'
import IconSearchLocation from '../../../assets/images/icon-search-location.svg'
import LocationModal from "../../../components/modal/location";
import EFQRcodePrinterModal from "../../../components/modal/ef-qrcode-printer";

const Container = styled.div`
    width: calc(100% - 32px);
    background-color: #FFFFFF;
    padding: 40px 16px;
    border-radius: 16px;

    .header-box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;

        .header-label {
            width: fit-content;
            color: #25368D;
            font-size: 20px;
            font-weight: 600;
            line-height: 29.9px;
            text-align: left;
            padding: 2px;
            border-width: 0px 0px 3px 0px;
            border-style: solid;
            border-color: #25368D;
        }
    }

    .data-box {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .footer-bar {
        width: 100%;
        margin-top: 24px;

        .button-box {
            width: fit-content;
            display: flex;
            gap: 16px;
            margin-right: 0px;
            margin-left: auto;
        }
    }
`;

const InformationBox = styled.div`

    &.border {
        border-width: 0px 0px 1px 0px;
        border-style: solid;
        border-color: #F2F2F2;
    }

    .label-header-info {
        color: #2A2A2A;
        font-size: 20px;
        font-weight: 500;
        line-height: 29.9px;
        text-align: left;
        margin-bottom: 20px;

        .icon {
            margin-bottom: 2px;
            cursor: pointer;
        }
    }

    ::placeholder {
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        opacity: 1;
    }

    ::-ms-input-placeholder {
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        opacity: 1;
    }

    .card-type-box {
        &.selected {
            margin-bottom: 20px;
        }
    }
`;

const CardType = styled.div`
    width: 100%;
    height: 70px;
    border-radius: 16px;
    padding: 0px 16px;
    border: 1px solid #B5B5B5;
    color: #505050;
    font-size: 15px;
    font-weight: 600;
    line-height: 22.43px;
    text-align: left;
    cursor: pointer;
    transition: all 0.3s ease;

    &.disable-card {
        cursor: default;
        background-color: #B3B3B333;
        color: #838BB4;
    }

    &.normal-card {
        &:hover {
            background-color: #F2F5FE99;
        }
    }

    &.active {
        background-color: #F2F5FE;
        border: 1px solid #25368D;
        color: #25368D;
        font-size: 15px;
        font-weight: 600;
        line-height: 22.43px;
        text-align: left;
    }

    .icon-type-box {
        width: 28px;
        min-width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #E3E9FD;
        margin-right: 16px;
    }
`;

const ExampleBox = styled.div`
    width: 100%;
    height: 180px;
    border-radius: 16px;
    border: 1px solid #B5B5B5;
    overflow-y: auto;

    &.active {
        height: auto;
        max-height: 1000px;
        background-color: #F2F5FE;
        border: 1px solid #25368D;
    }
`;

const ImportFileBox = styled.div`
    width: calc(100% - 34px);
    height: calc(80px - 32px);
    border-radius: 16px;
    border: 1px solid #B5B5B5;
    padding: 16px;
    gap: 16px;
    margin-bottom: 16px;
    cursor: pointer;

    &.active {
        background-color: #F2F5FE;
        border: 1px solid #25368D;
    }

    &.error {
        border: 1px solid #F84242;
    }

    .image-file-box {
        width: 30px;
        min-width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #E3E9FD;
        padding: 2px 0px 0px 2px;

        .image-file {

        }
    }

    .label-box {
        width: calc(100% - 90px);

        .label-placeholder {
            color: #838BB4;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;
        }

        .label-file {
            width: 100%;
            color: #25368D;
            font-size: 15px;
            font-weight: 600;
            line-height: 22.43px;
            text-align: left;
        }
    }

    .image-clear-box {
        width: 24px;
        min-width: 24px;
        height: 24px;
        border-radius: 50%;
        background-color: #25368D;

        .image-clear {
            
        }
    }
`;

const ExportFileBox = styled.div`
    width: calc(100% - 32px);
    height: calc(80px - 32px);
    border-radius: 16px;
    padding: 16px;
    gap: 16px;

    .image-file-box {
        width: 30px;
        min-width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #E3E9FD;
        padding: 2px 0px 0px 2px;

        .image-file {

        }
    }

    .label-box {
        width: 100%;

        .label-file {
            width: fit-content;
            border-width: 0px 0px 1px 0px;
            border-style: solid;
            border-color: #25368D;
            color: #25368D;
            font-size: 15px;
            font-weight: 600;
            line-height: 22.43px;
            text-align: left;
            cursor: pointer;
        }
    }
`;

const QRCodeBox = styled.div`
    width: calc(100% - 34px);
    height: calc(190px - 32px);
    border-radius: 16px;
    border: 1px solid #25368D;
    background-color: #F2F5FE;
    padding: 16px;
    gap: 24px;

    &.anonymous {
        background-color: #EBF9F9;
    }

    .image-box {
        width: 160px;
        min-width: 160px;
        height: 100%;
        border-radius: 8px;
        background-color: #E3E9FD;
        padding: 2px 0px 0px 2px;
        cursor: pointer;
    }

    .label-box {
        width: 100%;

        .label-placeholder {
            color: #2A2A2A;
            font-size: 20px;
            font-weight: 500;
            line-height: 29.9px;
            text-align: left;
        }
    }
`;

const HeaderExample = styled.div`
    width: 100%;
    height: 50px;
    max-width: 768px;
    background-color: #FFFFFF;
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    justify-content: space-between;

    .btn-header {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        cursor: pointer;

        &.hide {
            cursor: default;
        }
    }

`;

function EFCreateUpdatePage() {
    const paramsRoute = useParams();
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [detailModal, setDetailModal] = useState({
        title: "",
        sub_title: "",
        type: "",
        button_label: "",
    });
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [openQRcodeModal, setOpenQRcodeModal] = useState(false);
    const [openLocationModal, setOpenLocationModal] = useState(false);

    const [information, setInformation] = useState({
        id: "",
        displayname: "",
        type: "",
        department_id: null,
        division_id: null,
        province: "",
        location_name: "",
        location_id: null,
        latitude: null,
        longitude: null,
        radius: 1000,
        start_date: null,
        end_date: null,
        start_time: null,
        end_time: null,
        status: "",
        file: null,
        file_name: "",
        url_qrcode: "",
        url_qrcode_anonymous: "",
    });

    const [evaluationFormData, setEvaluationFormData] = useState(null)
    const [detailPageForm, setDetailPageForm] = useState({
        currentPage: 1,
        groupIndex: 0,
        subFormIndex: 0,
    })
    const [back, setBack] = useState(false)

    const [informationError, setInformationError] = useState({
        displayname: false,
        department_id: false,
        division_id: false,
        location_id: false,
        start_date: false,
        end_date: false,
        start_time: false,
        end_time: false,
        file_name: false,
    });
    const [listDepartment, setListDepartment] = useState([]);
    const [listDivision, setListDivision] = useState([]);
    const [listProvince, setListProvince] = useState([]);
    const [listLocation, setListLocation] = useState([]);
    const listSportCategoryRef = useRef([])
    const [disableSave, setDisableSave] = useState(true);
    const inputFileRef = useRef(null)
    const [userProfile, setUserProfile] = useState(null);
    const [showHistory, setShowHistory] = useState([]);
    const [detailQRcodeModal, setDetailQRcodeModal] = useState({
        id: "",
        displayname: "",
        title: "",
        type: "",
        province: "",
        location: "",
        url_qrcode: "",
        qrcode_description: "",
    });

    useEffect(() => {
        onInit();
    }, [])

    async function onInit() {
        setIsLoading(true);
        let _isEdit = false;
        let _profile = localStorage.getItem("profile");
        try {
            _profile = JSON.parse(_profile)
        } catch { }
        let response = null;
        await onGetSportCategory();
        if (paramsRoute?.id) {
            _isEdit = true;
            response = await onGetData(paramsRoute.id);
        }
        if (_profile) {
            setUserProfile(_profile)
            if (_profile.user_department_id) {
                await onGetDepartmentById(_profile.user_department_id)
            } else {
                await onGetAllDepertment()
            }
        } else if (response) {
            await onGetDepartmentById(response.department_id)
        }
        if (!response) {
            const responseProvince = await onGetAllLocation();
            setListProvince(responseProvince);
        }
        setIsEdit(_isEdit)
        setTitle(_isEdit ? "แก้ไขแบบสอบถาม" : "สร้างแบบสอบถาม")
        setIsLoading(false);
    }
    async function onGetData(id) {
        let response = null;
        try {
            response = await CoreAPI.evaluationFormHttpService.evaluationFormById(id)
        } catch { }
        if (response) {
            let detail = {
                id: response.evaluation_form_evaluation_form_id,
                displayname: response.evaluation_form_evaluation_name,
                type: response.evaluation_form_evaluation_type,
                department_id: response.evaluation_form_department_id,
                division_id: response.evaluation_form_division_id,
                province: response.location_province,
                location_name: response.location_location_name,
                location_id: response.evaluation_form_location_id,
                latitude: response.evaluation_form_latitude || response.location_latitude,
                longitude: response.evaluation_form_longitude || response.location_longitude,
                radius: response.evaluation_form_radius || 1000,
                start_date: null,
                end_date: null,
                start_time: null,
                end_time: null,
                file: null,
                file_name: `${response.evaluation_form_evaluation_name}.xlsx`,
                url_qrcode: "",
                url_qrcode_anonymous: "",
            }
            if (response.evaluation_form_evaluation_data) {
                let _detail = JSON.parse(JSON.stringify(response.evaluation_form_evaluation_data))
                if (_detail.evaluation_form) {
                    _detail.evaluation_form = onSetSportCategoryComponent(_detail.evaluation_form)
                }
                setEvaluationFormData(_detail)
                setShowHistory([]);
            }
            if (response.evaluation_form_datetime_start) {
                detail.start_date = new Date(response.evaluation_form_datetime_start);
                detail.start_time = dayjs(detail.start_date).format("HH:mm");
            }
            if (response.evaluation_form_datetime_end) {
                detail.end_date = new Date(response.evaluation_form_datetime_end);
                detail.end_time = dayjs(detail.end_date).format("HH:mm");
            }
            const lineLiffId = process.env.REACT_APP_LINE_LIFF_ID || "";
            if (lineLiffId) {
                const lineUrl = 'https://liff.line.me';
                detail.url_qrcode = `${lineUrl}/${lineLiffId}?evaluation_form_id=${detail.id}`
                detail.url_qrcode_anonymous = `${lineUrl}/${lineLiffId}?evaluation_form_id=${detail.id}&mode=anonymous`
            }
            const responseDivision = await onGetDivisionByDepertmentId(detail.department_id);
            setListDivision(responseDivision)
            const responseProvince = await onGetAllLocation();
            setListProvince(responseProvince);
            const responseLocation = responseProvince.find(x => x.id === detail.province);
            setListLocation(responseLocation?.location || [])
            setInformation(detail)
            const check = onCheckValidInput(detail)
            setDisableSave(check)
        }
        return response;
    }
    async function onGetAllLocation() {
        let response = [];
        try {
            response = await CoreAPI.evaluationFormHttpService.evaluationFormGetListLocationGroupByProvince()
        } catch { }
        return response;
    }
    async function onGetDepartmentById(id) {
        let response = [];
        try {
            response = await CoreAPI.userHttpService.userGetDepertmentById(id)
        } catch { }
        if (response) {
            let list = [];
            const detail = {
                id: response.department_id,
                label: response.department_name,
            }
            list.push(detail);
            response = [...list]
        }
        setListDepartment(response)
    }
    async function onGetAllDepertment() {
        let response = null;
        try {
            response = await CoreAPI.userHttpService.userGetAllDepertment()
        } catch { }
        if (response) {
            let list = [];
            if (Array.isArray(response)) {
                list = JSON.parse(JSON.stringify(response));
                list = list.map(x => {
                    const detail = {
                        id: x.department_id,
                        label: x.department_name,
                    }
                    return detail
                })
            }
            response = [...list]
        }
        setListDepartment(response)
    }
    async function onGetDivisionByDepertmentId(id) {
        let response = [];
        try {
            const body = {
                list: [id]
            }
            response = await CoreAPI.userHttpService.userGetDivisionByDepertmentId(body)
        } catch { }
        if (response) {
            if (Array.isArray(response)) {
                response = response.map(x => {
                    const detail = {
                        id: x.division_id,
                        label: x.division_name,
                    }
                    return detail
                })
            }
            if (userProfile?.user_division_id) {
                response = response.filter(x => x.id === userProfile?.user_division_id);
            }
        }
        return response
    }
    async function onGetExampleFileById(id) {
        let response = null;
        try {
            response = await CoreAPI.evaluationFormHttpService.evaluationFormGetExampleById(id)
        } catch { }
        if (response) {
            const type = response.headers['content-type'];
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'example.xlsx';
            if (response.data) {
                if (contentDisposition) {
                    const matches = /filename="([^"]+)"/.exec(contentDisposition);
                    if (matches && matches[1]) {
                        fileName = matches[1];
                    }
                }
                const blob = new Blob([response.data], { type: type });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);

                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }
    }
    async function onGetEvalutionFormFileById(id, name) {
        let response = null;
        try {
            response = await CoreAPI.evaluationFormHttpService.evaluationFormGetFileById(id)
        } catch { }
        if (response) {
            const type = response.headers['content-type'];
            let fileName = `${name || 'evaluation_form'}.xlsx`;
            if (response.data) {
                const blob = new Blob([response.data], { type: type });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);

                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }
    }
    async function onGetSportCategory() {
        let response = null;
        try {
            response = await CoreAPI.evaluationFormHttpService.evaluationFormGetSportCategory()
        } catch { }
        if (Array.isArray(response)) {
            listSportCategoryRef.current = [...response];
        }
        return response;
    }
    async function onFormatExample(param) {
        let response = null;
        try {
            const body = {
                data: param
            }
            response = await CoreAPI.evaluationFormHttpService.evaluationFormFormatExample(body)
        } catch { }
        if (response) {
            let _detail = JSON.parse(JSON.stringify(response))
            if (_detail.evaluation_form) {
                _detail.evaluation_form = onSetSportCategoryComponent(_detail.evaluation_form)
            }
            setEvaluationFormData(_detail);
            setShowHistory([]);
        }
    }
    async function onCreate() {
        let response = null;
        try {
            let body = {
                evaluation_name: information.displayname,
                evaluation_type: information.type,
                evaluation_data: evaluationFormData,
                department_id: information.department_id,
                division_id: information.division_id,
                status: "INACTIVE",
            };
            if (information.type === "Place") {
                body.location_id = information.location_id;
                body.latitude = information.latitude;
                body.longitude = information.longitude;
                body.radius = information.radius || 1000;
            } else if (information.type === "Event") {
                body.latitude = information.latitude;
                body.longitude = information.longitude;
                body.radius = information.radius;
                const start_datetime = onCombineDateTime(information.start_date, information.start_time);
                const end_datetime = onCombineDateTime(information.end_date, information.end_time);
                body.datetime_start = start_datetime;
                body.datetime_end = end_datetime;
            } else if (information.type === "Service") {
                const start_datetime = onCombineDateTime(information.start_date, information.start_time);
                const end_datetime = onCombineDateTime(information.end_date, information.end_time);
                body.datetime_start = start_datetime;
                body.datetime_end = end_datetime;
            }
            response = await CoreAPI.evaluationFormHttpService.evaluationFormCreate(body)
        } catch { }
        if (response) {
            let detail = { ...detailModal }
            detail.title = response.success ? "บันทึกแบบสอบถามสำเร็จ" : "บันทึกแบบสอบถามล้มเหลว";
            detail.sub_title = response.success ? "คุณสามารถดูรายละเอียดแบบสอบถาม ได้ที่หน้าประวัติการสร้างแบบสอบถาม" : response.message;
            detail.button_label = response.success ? "กลับหน้าหลัก" : "ตกลง";
            detail.type = response.success ? "success" : "fail";
            setDetailModal(detail)
            setOpenModal(true)
        }
    }
    async function onUpdate() {
        let response = null;
        try {
            let body = {
                evaluation_form_id: information.id,
                evaluation_name: information.displayname,
                evaluation_type: information.type,
                evaluation_data: evaluationFormData,
                department_id: information.department_id,
                division_id: information.division_id,
            };
            if (information.type === "Place") {
                body.location_id = information.location_id;
                body.latitude = information.latitude;
                body.longitude = information.longitude;
                body.radius = information.radius || 1000;
            } else if (information.type === "Event") {
                body.latitude = information.latitude;
                body.longitude = information.longitude;
                body.radius = information.radius;
                const start_datetime = onCombineDateTime(information.start_date, information.start_time);
                const end_datetime = onCombineDateTime(information.end_date, information.end_time);
                body.datetime_start = start_datetime;
                body.datetime_end = end_datetime;
            } else if (information.type === "Service") {
                const start_datetime = onCombineDateTime(information.start_date, information.start_time);
                const end_datetime = onCombineDateTime(information.end_date, information.end_time);
                body.datetime_start = start_datetime;
                body.datetime_end = end_datetime;
            }
            response = await CoreAPI.evaluationFormHttpService.evaluationFormUpdate(body)
        } catch { }
        if (response) {
            let detail = { ...detailModal }
            detail.title = response.success ? "บันทึกแบบสอบถามสำเร็จ" : "บันทึกแบบสอบถามล้มเหลว";
            detail.sub_title = response.success ? "คุณสามารถดูรายละเอียดแบบสอบถาม ได้ที่หน้าประวัติการสร้างแบบสอบถาม" : response.message;
            detail.button_label = response.success ? "กลับหน้าหลัก" : "ตกลง";
            detail.type = response.success ? "success" : "fail";
            setDetailModal(detail)
            setOpenModal(true)
        }
    }
    function onCheckValidInput(param) {
        let check = false;
        if (!param.file_name
            || !param.type
            || !param.displayname
            || !param.department_id
            || !param.division_id
        ) {
            check = true;
        }
        if (param.type === "Place") {
            if (!param.location_id) {
                check = true;
            }
        } else if (param.type === "Event") {
            if (!param.start_date
                || !param.end_date
                || !param.start_time
                || !param.end_time
            ) {
                check = true;
            }
        } else if (param.type === "Service") {
            if (!param.start_date
                || !param.end_date
                || !param.start_time
                || !param.end_time
            ) {
                check = true;
            }
        }
        return check
    }
    function onCheckErrorInput(param) {
        let check = false;
        let detailError = { ...informationError }
        if (param.type === "Place") {
        } else if (param.type === "Event") {
            const start_datetime = onCombineDateTime(param.start_date, param.start_time);
            const end_datetime = onCombineDateTime(param.end_date, param.end_time);
            if (end_datetime.getTime() < start_datetime.getTime()) {
                check = true;
                detailError.start_date = check;
                detailError.end_date = check;
                detailError.start_time = check;
                detailError.end_time = check;
            }
        } else if (param.type === "Service") {
            const start_datetime = onCombineDateTime(param.start_date, param.start_time);
            const end_datetime = onCombineDateTime(param.end_date, param.end_time);
            if (end_datetime.getTime() < start_datetime.getTime()) {
                check = true;
                detailError.start_date = check;
                detailError.end_date = check;
                detailError.start_time = check;
                detailError.end_time = check;
            }
        }
        setInformationError(detailError);
        return check;
    }
    function onCombineDateTime(date, time) {
        const newDate = new Date(date);
        const newTime = time;

        // Split the time string into hours and minutes
        const [hours, minutes] = newTime.split(':').map(Number);

        // Set the hours and minutes to the Date object
        newDate.setHours(hours);
        newDate.setMinutes(minutes);
        return newDate
    }
    function onReadFile(fileUploaded) {
        if (!fileUploaded) return;
        let detail = { ...information };
        let detailError = { ...informationError };
        const filename = fileUploaded.name;
        const mimeType = fileUploaded.type;
        const allowType = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel",
        ]
        if (!allowType.includes(mimeType)) {
            detailError.file_name = true;
            setInformationError(detailError);
            return;
        }
        const reader = new FileReader();
        reader.onload = (event) => {
            setEvaluationFormData(null);
            setShowHistory([]);
            const data = formatExceltoJSON(event.target.result);
            const checkData = checkFormatEvaluationFormData(data);
            if (checkData) {
                detail.file = fileUploaded;
                detail.file_name = filename;
                setInformation(detail)
                onFormatExample(data)
                detailError.file_name = false;
            } else {
                if (!detail.file_name) {
                    detailError.file_name = true;
                }
            }
            const check = onCheckValidInput(detail)
            setDisableSave(check)
            setInformationError(detailError);
        };
        reader.readAsBinaryString(fileUploaded);
    }
    function onSetSportCategoryComponent(param) {
        const detail = {
            "tag": "ประเภทกีฬา",
            // "type": "radio",
            "type": "dropdown_filter",
            "title": "ประเภทกีฬา",
            "answer": null,
            // "choice": [
            //     {
            //         "label": "ฟุตบอล",
            //         "value": "ฟุตบอล"
            //     },
            //     {
            //         "label": "บาสเกตบอล",
            //         "value": "บาสเกตบอล"
            //     },
            //     {
            //         "label": "เทเบิลเทนนิส	",
            //         "value": "เทเบิลเทนนิส	"
            //     }
            // ],
            "choice": [...listSportCategoryRef.current],
            "required": false,
            "hidden": true,
        }
        for (let item of param) {
            if (item.form_type === "single_level") {
                const indexSporter = item.form?.findIndex(x => x.tag === "ประเภทผู้ประเมิน");
                const indexSportCategory = item.form?.findIndex(x => x.tag === "ประเภทกีฬา");
                if (indexSporter >= 0 && indexSportCategory < 0) {
                    item.form.splice(indexSporter + 1, 0, detail);
                    break;
                }
            } else if (item.form_type === "group_level") {
                // console.log(item)
            }
        }
        return param;
    }
    // ========== ========== Handle ========== ==========
    async function handleChangeInformation(key, value) {
        let detail = { ...information };
        let detailError = { ...informationError };
        detail[key] = value;
        if (key === "department_id") {
            detail.division_id = null;
            const response = await onGetDivisionByDepertmentId(value)
            setListDivision(response)
        }
        if (key === "province") {
            detail.location_id = null;
            detail.latitude = null;
            detail.longitude = null;
            const responseLocation = listProvince.find(x => x.id === detail[key]);
            setListLocation(responseLocation?.location || [])
        }
        if (key === "location_id") {
            let model = listLocation.find(x => x.id === value);
            detail.latitude = model?.latitude || null;
            detail.longitude = model?.longitude || null;
        }
        if (detailError[key] !== undefined && detail[key]) {
            detailError[key] = false;
        }
        setInformation(detail)
        setInformationError(detailError)
        const check = onCheckValidInput(detail)
        setDisableSave(check)
    }
    async function handleConfirm() {
        let checkError = onCheckErrorInput(information);
        if (checkError) {
            const element = document.getElementById("backoffice-main-layout");
            if (element) {
                element.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth"
                });
            }
            return;
        }
        setOpenConfirmModal(true)
    }
    async function handleConfirmModal() {
        setIsLoading(true)
        setOpenConfirmModal(false)
        if (isEdit) {
            await onUpdate();
        } else {
            await onCreate();
        }
        setIsLoading(false)
    }
    function handleBack(param) {
        if (param === "modal") {
            if (detailModal.type === "success") {
                navigate(`/ef-management/list-view`);
            } else {
                setOpenModal(false)
            }
        } else {
            navigate(`/ef-management/list-view`);
        }
    }
    function handleChangeEFType(params) {
        if (isEdit) return;
        let detail = { ...information }
        detail.type = params;
        setInformation(detail)
        const check = onCheckValidInput(detail)
        setDisableSave(check)
    }
    function handleDownloadQrCode(id) {
        const qrCodeElement = document.getElementById(id);
        if (!qrCodeElement) return
        htmlToImage
            .toSvg(qrCodeElement)
            .then(function (dataUrl) {
                const link = document.createElement("a");
                link.href = dataUrl;
                link.download = `${id}.svg`;
                link.click();
            })
            .catch(function (error) {
                console.error("Error generating QR code:", error);
            });
    }
    function handleOpenQRExam(param) {
        const detail = {
            ...detailQRcodeModal,
            title: "",
            type: "",
            province: "",
            location: "",
        }
        detail.id = information.id;
        detail.displayname = information.displayname;
        if (param === "normal") {
            detail.anonymous = false;
            detail.url_qrcode = information.url_qrcode;
            detail.qrcode_description = "แบบสอบถามด้วยคิวอาร์โค้ด";
        } else if (param === "anonymous") {
            detail.anonymous = true;
            detail.url_qrcode = information.url_qrcode_anonymous;
            detail.qrcode_description = "แบบสอบถามไม่ระบุตัวตนด้วยคิวอาร์โค้ด";
        }
        detail.title = evaluationFormData?.title;
        detail.type = information.type;
        detail.province = information.province;
        detail.location = information.location_name;
        setDetailQRcodeModal(detail);
        setOpenQRcodeModal(true);
    }
    function handleCloseQRCode() {
        setOpenQRcodeModal(false)
    }
    function handleClickBack() {
        setBack(true)
    }
    function handleOpenLocationModal() {
        setOpenLocationModal(true)
    }
    function handleConfirmLocationModal(param) {
        let detail = {
            ...information,
            latitude: param.latitude,
            longitude: param.longitude,
            radius: param.radius || 1000,
        }
        setInformation(detail)
        setOpenLocationModal(false)
    }
    function handleCloseLocationModal() {
        setOpenLocationModal(false)
    }
    // ========== ========== Handle File ========== ==========
    function handleClearFile(event) {
        event.stopPropagation();
        inputFileRef.current.value = null;
        let detail = { ...information };
        detail.file = null;
        detail.file_name = "";
        setInformation(detail)
        setEvaluationFormData(null);
        setShowHistory([]);
    }
    function handleClickFile() {
        inputFileRef.current.click();
    }
    function handleDrop(event) {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;
        if (droppedFiles.length > 0) {
            onReadFile(droppedFiles[0])
        }
    };
    function handleChangeFile(event) {
        const fileUploaded = event.target.files[0];
        if (fileUploaded) {
            onReadFile(fileUploaded)
        }
    }
    function handleClickExampleFile() {
        onGetExampleFileById(information.type)
    }
    // ========== ========== Handle Example Form ========== ==========
    function handleBackForm(param) {
        setBack(false)
    }
    function handleUpdateEvaluationFormHistory(param) {
        setShowHistory(param)
    }
    function handleEvaluationFormData(param) {
        setEvaluationFormData(param);
    }
    function handleEndEvaluationForm(param, detail) {
        setDetailPageForm(detail)
    }
    function handleClickBack() {
        setBack(true)
    }
    function handleClickDownloadFile() {
        onGetEvalutionFormFileById(information.id, information.displayname)
    }
    // ========== ========== ========== ==========

    return (
        <BackOfficeLayout>
            <LoadingModal open={isLoading} />
            <SuccessModal
                open={openModal}
                onConfirm={(e) => handleBack("modal")}
                title={detailModal.title}
                subTitle={detailModal.sub_title}
                type={detailModal.type}
                buttonLabel={detailModal.button_label}
            />
            <ConfirmModal
                open={openConfirmModal}
                title={"ยืนยันเพื่อบันทึกแบบสอบถาม"}
                labelBack={"ยกเลิก"}
                labelConfirm={"ยืนยัน"}
                onBack={(e) => setOpenConfirmModal(false)}
                onConfirm={handleConfirmModal}
            />
            <LocationModal
                open={openLocationModal}
                onConfirm={handleConfirmLocationModal}
                onClose={handleCloseLocationModal}
                detailMap={information}
            />
            <EFQRcodePrinterModal
                open={openQRcodeModal}
                dataItem={detailQRcodeModal}
                buttonLabel={"ปิด"}
                onConfirm={handleCloseQRCode}
            />
            <Container>
                <div className="header-box vertical-center">
                    <div className="header-label">
                        {title}
                    </div>
                </div>
                <div className="data-box">
                    <InformationBox>
                        <div className="label-header-info vertical-center">
                            เลือกประเภทแบบสอบถาม
                        </div>
                        <div className={`vertical-center card-type-box`} style={{ gap: "24px", marginBottom: "24px" }}>
                            <CardType className={`vertical-center ${isEdit ? "disable-card" : "normal-card"} ${information.type === "Place" ? "active" : ""}`}
                                onClick={(e) => handleChangeEFType("Place")}>
                                <div className="content-center icon-type-box">
                                    <img alt="img" src={IconPlace} style={{ width: "16px" }} />
                                </div>
                                Place
                            </CardType>
                            <CardType className={`vertical-center ${isEdit ? "disable-card" : "normal-card"} ${information.type === "Event" ? "active" : ""}`}
                                onClick={(e) => handleChangeEFType("Event")}>
                                <div className="content-center icon-type-box">
                                    <img alt="img" src={IconEvent} style={{ width: "16px" }} />
                                </div>
                                Event
                            </CardType>
                            <CardType className={`vertical-center ${isEdit ? "disable-card" : "normal-card"} ${information.type === "Service" ? "active" : ""}`}
                                onClick={(e) => handleChangeEFType("Service")}>
                                <div className="content-center icon-type-box">
                                    <img alt="img" src={IconService} style={{ width: "16px" }} />
                                </div>
                                Service
                            </CardType>
                        </div>

                        {information.type &&
                            <div>
                                <div className="horizontal-center" style={{ justifyContent: "space-between", marginBottom: "20px" }}>
                                    <div className="label-header-info vertical-center" style={{ marginBottom: "0px" }}>
                                        ชื่อแบบสอบถาม
                                    </div>
                                    {information.type !== "Service" &&
                                        <ButtonComponent
                                            label={"ค้นหาจากแผนที่"}
                                            variant={"secondary"}
                                            sceenSize={"lg"}
                                            icon={IconSearchLocation}
                                            style={{ width: "180px", maxWidth: "180px", minWidth: "180px" }}
                                            onClick={handleOpenLocationModal}
                                        />
                                    }
                                </div>
                                <div className="vertical-center">
                                    <InputComponent
                                        placeholder={"กรุณากรอกชื่อแบบสอบถาม"}
                                        styleInput={{ border: "1px solid #B5B5B5" }}
                                        value={information.displayname}
                                        isError={informationError.displayname}
                                        onInput={(e) => { handleChangeInformation("displayname", e) }}
                                    />
                                </div>
                                <div className="vertical-center" style={{ gap: "24px" }}>
                                    <div style={{ width: "calc(50% - 12px)" }}>
                                        <DropdownComponent
                                            label={"ฝ่าย"}
                                            placeholder={"กรุณาเลือกฝ่าย"}
                                            list={listDepartment}
                                            value={{ id: information.department_id }}
                                            isError={informationError.department_id}
                                            onSelect={(e) => { handleChangeInformation("department_id", e?.id) }}
                                        />
                                    </div>
                                    <div style={{ width: "calc(50% - 12px)" }}>
                                        <DropdownComponent
                                            label={"กอง"}
                                            placeholder={"กรุณาเลือกกอง"}
                                            list={listDivision}
                                            value={{ id: information.division_id }}
                                            isError={informationError.division_id}
                                            onSelect={(e) => { handleChangeInformation("division_id", e?.id) }}
                                        />
                                    </div>
                                </div>

                                {/* ========== ========== ========== ========== */}
                                {information.type === "Place" &&
                                    <>
                                        <div className="label-header-info vertical-center">
                                            สถานที่ของแบบสอบถาม
                                        </div>
                                        <div className="vertical-center">
                                            <DropdownComponent
                                                placeholder={"เลือกจังหวัด"}
                                                list={listProvince}
                                                value={{ id: information.province }}
                                                onSelect={(e) => { handleChangeInformation("province", e?.id) }}
                                            />
                                        </div>
                                        <div className="vertical-center">
                                            <DropdownComponent
                                                placeholder={"เลือกสถานที่"}
                                                list={listLocation}
                                                value={{ id: information.location_id }}
                                                isError={informationError.location_id}
                                                onSelect={(e) => { handleChangeInformation("location_id", e?.id) }}
                                            />
                                        </div>
                                    </>
                                }

                                {/* ========== ========== ========== ========== */}
                                {information.type === "Event" &&
                                    <>
                                        <div className="label-header-info vertical-center">
                                            กำหนดวันที่เริ่มต้น
                                        </div>
                                        <div className="vertical-center" style={{ gap: "24px" }}>
                                            <div style={{ width: "calc(50% - 12px)" }}>
                                                <DatePickerComponent
                                                    label={"วันที่"}
                                                    placeholder={"เลือกวันที่เริ่มต้น"}
                                                    value={information.start_date}
                                                    type={"backoffice"}
                                                    noMaxDate={true}
                                                    isError={informationError.start_date}
                                                    onSelect={(e) => handleChangeInformation("start_date", e)}
                                                />
                                            </div>
                                            <div style={{ width: "calc(50% - 12px)" }}>
                                                <TimePickerComponent
                                                    label={"เวลา"}
                                                    placeholder={"เลือกเวลา"}
                                                    value={information.start_time}
                                                    type={"backoffice"}
                                                    isError={informationError.start_time}
                                                    onSelect={(e) => { handleChangeInformation("start_time", e) }}
                                                />
                                            </div>
                                        </div>

                                        <div className="label-header-info vertical-center">
                                            กำหนดวันที่สิ้นสุด
                                        </div>
                                        <div className="vertical-center" style={{ gap: "24px" }}>
                                            <div style={{ width: "calc(50% - 12px)" }}>
                                                <DatePickerComponent
                                                    label={"วันที่"}
                                                    placeholder={"เลือกวันที่สิ้นสุด"}
                                                    value={information.end_date}
                                                    type={"backoffice"}
                                                    noMaxDate={true}
                                                    isError={informationError.end_date}
                                                    onSelect={(e) => handleChangeInformation("end_date", e)}
                                                />
                                            </div>
                                            <div style={{ width: "calc(50% - 12px)" }}>
                                                <TimePickerComponent
                                                    label={"เวลา"}
                                                    placeholder={"เลือกเวลา"}
                                                    value={information.end_time}
                                                    type={"backoffice"}
                                                    isError={informationError.end_time}
                                                    onSelect={(e) => { handleChangeInformation("end_time", e) }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }

                                {/* ========== ========== ========== ========== */}
                                {information.type === "Service" &&
                                    <>
                                        <div className="label-header-info vertical-center">
                                            กำหนดวันที่เริ่มต้น
                                        </div>
                                        <div className="vertical-center" style={{ gap: "24px" }}>
                                            <div style={{ width: "calc(50% - 12px)" }}>
                                                <DatePickerComponent
                                                    label={"วันที่"}
                                                    placeholder={"เลือกวันที่เริ่มต้น"}
                                                    value={information.start_date}
                                                    type={"backoffice"}
                                                    noMaxDate={true}
                                                    isError={informationError.start_date}
                                                    onSelect={(e) => handleChangeInformation("start_date", e)}
                                                />
                                            </div>
                                            <div style={{ width: "calc(50% - 12px)" }}>
                                                <TimePickerComponent
                                                    label={"เวลา"}
                                                    placeholder={"เลือกเวลา"}
                                                    value={information.start_time}
                                                    type={"backoffice"}
                                                    isError={informationError.start_time}
                                                    onSelect={(e) => { handleChangeInformation("start_time", e) }}
                                                />
                                            </div>
                                        </div>

                                        <div className="label-header-info vertical-center">
                                            กำหนดวันที่สิ้นสุด
                                        </div>
                                        <div className="vertical-center" style={{ gap: "24px" }}>
                                            <div style={{ width: "calc(50% - 12px)" }}>
                                                <DatePickerComponent
                                                    label={"วันที่"}
                                                    placeholder={"เลือกวันที่สิ้นสุด"}
                                                    value={information.end_date}
                                                    type={"backoffice"}
                                                    noMaxDate={true}
                                                    isError={informationError.end_date}
                                                    onSelect={(e) => handleChangeInformation("end_date", e)}
                                                />
                                            </div>
                                            <div style={{ width: "calc(50% - 12px)" }}>
                                                <TimePickerComponent
                                                    label={"เวลา"}
                                                    placeholder={"เลือกเวลา"}
                                                    value={information.end_time}
                                                    type={"backoffice"}
                                                    isError={informationError.end_time}
                                                    onSelect={(e) => { handleChangeInformation("end_time", e) }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }

                                {/* ========== ========== ========== ========== */}
                                {information.type &&
                                    <div style={{ display: "flex", gap: "24px" }}>
                                        <div style={{ width: "calc(50% - 12px)" }}>
                                            <div className="label-header-info vertical-center">
                                                อัปโหลดไฟล์แบบสอบถาม
                                            </div>
                                            <ImportFileBox className={`vertical-center ${informationError.file_name ? "error" : information.file_name ? "active" : ""}`}
                                                onClick={handleClickFile}
                                                onDrop={handleDrop}
                                                onDragOver={(event) => event.preventDefault()}
                                            >
                                                <input
                                                    ref={inputFileRef}
                                                    style={{ display: "none" }}
                                                    type="file"
                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    onChange={handleChangeFile}
                                                />
                                                <div className="image-file-box content-center">
                                                    <img className="image-file" alt="img" src={IconReport} />
                                                </div>
                                                <div className="label-box">
                                                    {information.file_name ?
                                                        <div className="label-file text-overflow-dot">{information.file_name}</div>
                                                        :
                                                        <div className="label-placeholder">Drag & Drop หรือคลิกเพื่ออัปโหลดไฟล์ที่นี่<br />(รองรับเฉพาะไฟล์ xlsx เท่านั้น)</div>
                                                    }
                                                </div>
                                                {information.file_name &&
                                                    <div className="image-clear-box content-center" onClick={handleClearFile}>
                                                        <img className="image-clear" alt="img" src={IconClear} />
                                                    </div>
                                                }
                                            </ImportFileBox>
                                            {information.id &&
                                                <ExportFileBox className="vertical-center">
                                                    <div className="image-file-box content-center">
                                                        <img className="image-file" alt="img" src={IconXLSX} />
                                                    </div>
                                                    <div className="label-box" onClick={handleClickDownloadFile}>
                                                        <div className="label-file">ดาวน์โหลดแบบสอบถามปัจจุบัน</div>
                                                    </div>
                                                </ExportFileBox>
                                            }
                                            <ExportFileBox className="vertical-center" style={{ marginBottom: "16px" }}>
                                                <div className="image-file-box content-center">
                                                    <img className="image-file" alt="img" src={IconXLSX} />
                                                </div>
                                                <div className="label-box" onClick={handleClickExampleFile}>
                                                    <div className="label-file">ดาวน์โหลดตัวอย่างแบบสอบถาม</div>
                                                </div>
                                            </ExportFileBox>
                                            {information.url_qrcode &&
                                                <QRCodeBox className="vertical-center">
                                                    <div className="label-box">
                                                        <div className="label-placeholder">ดูตัวอย่างแบบสอบถาม<br />ด้วยคิวอาร์โค้ด</div>
                                                        <ButtonComponent
                                                            label={"พิมพ์คิวอาร์โค้ด"}
                                                            icon={IconPrinter}
                                                            variant={"primary"}
                                                            sceenSize={"lg"}
                                                            style={{
                                                                width: "190px",
                                                                maxWidth: "190px",
                                                                minWidth: "190px",
                                                                height: "40px",
                                                                marginTop: "12px",
                                                                fontSize: "15px",
                                                                fontWeight: "500",
                                                            }}
                                                            onClick={(e) => handleOpenQRExam("normal")}
                                                        />
                                                    </div>
                                                    <div className="image-box content-center" onClick={(e) => handleDownloadQrCode("qrcode")}>
                                                        <QRCode
                                                            id="qrcode"
                                                            value={information.url_qrcode}
                                                            size={160}
                                                        />
                                                    </div>
                                                </QRCodeBox>
                                            }
                                            {information.url_qrcode_anonymous &&
                                                <QRCodeBox className="vertical-center anonymous" style={{ marginTop: "16px" }}>
                                                    <div className="label-box">
                                                        <div className="label-placeholder">ดูตัวอย่างแบบสอบถามไม่ระบุตัวตน<br />ด้วยคิวอาร์โค้ด</div>
                                                        <ButtonComponent
                                                            label={"พิมพ์คิวอาร์โค้ด"}
                                                            icon={IconPrinter}
                                                            variant={"primary"}
                                                            sceenSize={"lg"}
                                                            style={{
                                                                width: "190px",
                                                                maxWidth: "190px",
                                                                minWidth: "190px",
                                                                height: "40px",
                                                                marginTop: "12px",
                                                                fontSize: "15px",
                                                                fontWeight: "500",
                                                            }}
                                                            onClick={(e) => handleOpenQRExam("anonymous")}
                                                        />
                                                    </div>
                                                    <div className="image-box content-center" onClick={(e) => handleDownloadQrCode("qrcode-anonymous")}>
                                                        <QRCode
                                                            id="qrcode-anonymous"
                                                            value={information.url_qrcode_anonymous}
                                                            size={160}
                                                        />
                                                    </div>
                                                </QRCodeBox>
                                            }

                                        </div>
                                        <div style={{ width: "calc(50% - 12px)" }}>
                                            <div className="label-header-info vertical-center">
                                                ตัวอย่างแบบสอบถามที่อัปโหลด
                                            </div>
                                            <ExampleBox className={`${evaluationFormData ? 'active' : ''}`}>
                                                {evaluationFormData &&
                                                    <div style={{ padding: "8px" }}>
                                                        <HeaderExample className="vertical-center">
                                                            <div className="content-center btn-header" onClick={handleClickBack}>
                                                                <img alt="img" src={IconArrow} style={{ width: "30px" }} />
                                                            </div>
                                                            <div>การกีฬาแห่งประเทศไทย</div>
                                                            <div className="content-center btn-header">
                                                            </div>
                                                        </HeaderExample>
                                                        <div style={{ backgroundColor: "#FFFFFF" }}>
                                                            <EvaluationFormLayout
                                                                back={back}
                                                                onBack={handleBackForm}
                                                                evaluationFormData={evaluationFormData}
                                                                detailPageForm={detailPageForm}
                                                                evaluationFormHistory={showHistory}
                                                                onUpdateEvaluationFormHistory={handleUpdateEvaluationFormHistory}
                                                                onUpdateEvaluationFormData={handleEvaluationFormData}
                                                                onEndEvaluationForm={handleEndEvaluationForm}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                            </ExampleBox>
                                        </div>
                                    </div>
                                }
                            </div>
                        }

                    </InformationBox>
                </div>
                {information.type &&
                    <div className="footer-bar">
                        <div className="button-box">
                            <ButtonComponent
                                label={"ยกเลิก"}
                                variant={"secondary"}
                                sceenSize={"lg"}
                                style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
                                onClick={(e) => handleBack("bar")}
                            />
                            <ButtonComponent
                                disable={disableSave}
                                label={"ยืนยัน"}
                                variant={"primary"}
                                sceenSize={"lg"}
                                style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
                                onClick={handleConfirm}
                            />
                        </div>
                    </div>
                }
            </Container>
        </BackOfficeLayout>
    )
}

export default EFCreateUpdatePage;